import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import * as generic from '../../../../components/Generico';
import { Patrimonio } from '../../../../models/trust/empleado/Patrimonio';
import { EmpleadoAcDirService } from '../../../../service/trust/empleado/EmpleadoAcDirService';
import { DetalleIngresoEgreso } from '../../../../components/trust/DetalleIngresoEgreso';
import { DetalleTarjeta } from '../../../../components/trust/DetalleTarjeta';
import { ReferenciaPersonal } from '../../../../components/trust/ReferenciaPersonal';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const PatrimonioDetalle = ({ toast, id, permss, catalogos, handlePrev, handleNext, nuevoEmpleado, soloLectura }) => {
    const omodel = new Patrimonio();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });
    const empleadoServicio = new EmpleadoAcDirService();
    const { inText } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    // Estados de interfaz y persistencia
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [informacion, setInformacion] = useState(null);

    useEffect(() => {
        editFicha();
        //eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion4';

        empleadoServicio.editar(data).then(res => {
            nuevoEmpleado(res.data);
            generic.funcSuccess(res, toast);
            handleNext();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const editFicha = () => {
        setIsLoading(true);
        empleadoServicio.consultar(id, { seccion: 'seccion4' }).then(res => {
            let _emp = res.data.empleado;
            setInformacion(_emp);

            if (!_emp) {
                reset(defaultValues);
                return;
            }

            reset(generic.renewValues(_emp, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form id="form-patrimonio" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('7', 'PATRIMONIO', 'pi pi-chart-line')} className="panel-ficha shadow-1 mb-4">
                    <div className="grid formgrid mb-4 px-2 mt-2">
                        <div className="col-12 md:col-4">
                            <div className="p-3 surface-50 border-round h-full flex flex-column shadow-1 align-items-center justify-content-center border-top-3 border-blue-400">
                                <span className="text-600 font-bold mb-2 text-sm">TOTAL DEL ACTIVO</span>
                                <span className="text-2xl font-bold text-700">${informacion?.total_activo || '0.00'}</span>
                            </div>
                        </div>
                        <div className="col-12 md:col-4 mt-3 md:mt-0">
                            <div className="p-3 surface-50 border-round h-full flex flex-column shadow-1 align-items-center justify-content-center border-top-3 border-pink-400">
                                <span className="text-600 font-bold mb-2 text-sm">TOTAL DEL PASIVO</span>
                                <span className="text-2xl font-bold text-700">${informacion?.total_pasivo || '0.00'}</span>
                            </div>
                        </div>
                        <div className="col-12 md:col-4 mt-3 md:mt-0">
                            <div className="bg-blue-50 p-3 border-round border-1 border-blue-200 shadow-2 h-full flex flex-column align-items-center justify-content-center">
                                <span className="text-blue-800 font-bold mb-2 text-sm">TOTAL DEL PATRIMONIO</span>
                                <span className="text-2xl font-bold text-blue-900">${informacion?.patrimonio || '0.00'}</span>
                            </div>
                        </div>
                    </div>
                    <div className="grid formgrid px-2 justify-content-center">
                        {inText('anio_declaracion_renta', { icon: 'pi pi-calendar', iconPosition: 'left' }, 4)}
                    </div>
                </Panel>
            </form>

            <Panel header={generic.renderPanelHeader('8', 'DETALLE DE INGRESOS Y EGRESOS', 'pi pi-sort-alt')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid p-2">
                    <div className="col-12 md:col-6 mb-4 md:mb-0">
                        <DetalleIngresoEgreso esIngreso={true} id={id} toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                    </div>
                    <div className="col-12 md:col-6">
                        <DetalleIngresoEgreso esIngreso={false} id={id} toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                    </div>
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('9', 'DETALLE DE TARJETAS DE CRÉDITO', 'pi pi-credit-card')} className="panel-ficha shadow-1 mb-4">
                <div className="p-2">
                    <DetalleTarjeta id={id} toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('10', 'REFERENCIAS PERSONALES', 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
                <div className="p-2">
                    <ReferenciaPersonal tipo="empleadoAcDir" id={id} toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" formId="form-patrimonio" onPrev={handlePrev} onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </>
    );
}